import UserLinkProfile from './UserLinkProfile';

export default UserLinkProfile;
